/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Membership_Cancellation_Scheduled_DescriptionInputs */

const fr_membership_cancellation_scheduled_description = /** @type {(inputs: Membership_Cancellation_Scheduled_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre accès reste actif jusqu'au ${i?.date}.`)
};

/**

* @param {Membership_Cancellation_Scheduled_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_cancellation_scheduled_description = /** @type {((inputs: Membership_Cancellation_Scheduled_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Cancellation_Scheduled_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_cancellation_scheduled_description(inputs)
});